import React, { ChangeEvent } from "react";
import styles from "./styles.module.css";
import checkBoxStyles from "./checkbox.module.css";
import PropTypes from "prop-types";
import { FaCheck, FaMusic } from "react-icons/fa";
import { getRegExp, getSentenceFromCamelCase } from "./Helpers";

const Checkbox = ({
  disabled,
  error,
  fixLength,
  required,
  label,
  minLength,
  maxLength,
  name,
  onChange,
  data,
  reqType,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  filter,
}: any) => {
  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value: itemValue, checked } = event.target;
    const updatedValues = Array.isArray(value) ? [...value] : [];

    if (checked) {
      if (!updatedValues.includes(itemValue)) updatedValues.push(itemValue);
    } else {
      const index = updatedValues.indexOf(itemValue);
      if (index > -1) updatedValues.splice(index, 1);
    }

    onChange && onChange(name, updatedValues);
  };

  const onValidationChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!validationHandler) return;
    const { value } = event.target;
    let errorMessage = "";
    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    } else if (minLength && value.length < minLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be at least ${minLength} characters long.`;
    } else if (maxLength && value.length > maxLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${maxLength} characters long.`;
    } else if (fixLength && value.length !== fixLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${fixLength} characters.`;
    } else if (value && reqType && !getRegExp(reqType)?.test(value)) {
      errorMessage = `Please enter valid ${getSentenceFromCamelCase(name)}.`;
    }
    validationHandler(name, errorMessage);
  };

  return (
    <div className={`${styles.radioFlex} ${styles[size || "medium"]}`}>
      <div className={styles.labelRow}>
        <label htmlFor={name} className={`${styles.label} ${labelClassName || ""}`}>
          {label}
          {required && <span className={styles.required}>&nbsp;*</span>}
        </label>
        {error ? <span className={styles.errorText}>{error}</span> : null}
      </div>

      <div className={checkBoxStyles.checkboxGrid}>
        {data.map((item: any, i: number) => {
          const itemValue = filter ? item[filter] : item.value;
          const checked = Array.isArray(value) && value.includes(itemValue);

          return (
            <label
              key={`${name}-${itemValue}-${i}`}
              className={`${checkBoxStyles.checkboxCard} ${checked ? checkBoxStyles.checked : ""} ${disabled ? checkBoxStyles.disabled : ""}`}
            >
              <input
                id={`${name}-${i}`}
                type="checkbox"
                onChange={onChangeHandler}
                value={itemValue}
                name={name}
                checked={checked}
                required={required}
                onBlur={onValidationChange}
                disabled={disabled}
              />
              <span className={checkBoxStyles.checkboxIcon}>
                {checked ? <FaCheck /> : <FaMusic />}
              </span>
              <span className={checkBoxStyles.checkboxLabel}>{itemValue}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

Checkbox.defaultProps = {
  checked: false,
  className: "",
  disabled: false,
  error: "",
  fixLength: 0,
  required: false,
  label: "",
  minLength: 0,
  maxLength: 0,
  placeholder: "",
  reqType: "",
  style: {},
  type: "checkbox",
  validationHandler: () => {},
  size: "medium",
  labelClassName: "",
  value: [],
  data: [],
  filter: "",
};

Checkbox.propTypes = {
  filter: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  fixLength: PropTypes.number,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  reqType: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  validationHandler: PropTypes.func,
  value: PropTypes.array,
  size: PropTypes.string,
  labelClassName: PropTypes.string,
  data: PropTypes.array,
};

export default Checkbox;
